<template>
  <section
    id="dashboard-ecommerce"
    class="dashboard-scale"
  >
    <!-- <b-card-code class="align-content-center">
      <div class="demo-spacing-0">
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <span>You have 8 days left to settle the payment for the previous subscription invoice.</span>
          </div>
        </b-alert>
      </div>
    </b-card-code> -->
    <b-row class="match-height">
      <b-col
        md="4"
        class="align-content-center"
      >
        <ecommerce-statistics
          :data="tempdata.statisticsItems"
          :last-updated-at="mainDashboard.orderStatsData.last_updated_at"
          queue="status-statistics"
          @refresh="fetchWidgetRefreshTime"
        />
      </b-col>
      <b-col
        md="8"
        class="align-content-center"
      >
        <ecommerce-financial-statistics
          :data="tempdata.financialstatisticsItems"
          :last-updated-at="mainDashboard.financialStatsData.last_updated_at"
          queue="finance-statistics"
          @refresh="fetchWidgetRefreshTime"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        md="6"
      >
        <div v-if="!isMonthlyEarningsLoading && businessProfileCurrency">
          <ecommerce-monthly-earnings-chart
            :data="tempdata.monthlyEarnings"
            :last-updated-at="mainDashboard.monthlyEarningsData.last_updated_at"
            queue="monthly-earnings"
            @refresh="fetchWidgetRefreshTime"
          />
        </div>
      </b-col>
      <b-col
        md="6"
      >
        <div v-if="!isBarChartLoading">
          <ecommerce-revenue-report
            :data="tempdata.monthlyOrders"
            :last-updated-at="mainDashboard.monthlyOrdersData.last_updated_at"
            queue="monthly-orders"
            @refresh="fetchWidgetRefreshTime"
          />
        </div>
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        md="6"
      >
        <div
          v-if="!isToBeInvoicesLoading"
        >
          <ecommerce-transactions
            :data="tempdata.toBeInvoices"
            :last-updated-at="mainDashboard.toBeInvoicesData.last_updated_at"
            queue="to-be-invoice"
            @refresh="fetchWidgetRefreshTime"
          />
        </div>
      </b-col>

      <b-col
        md="6"
      >
        <div
          v-if="!isDeliveredFailedLoading"
        >
          <ecommerce-delivered-failed
            :data="tempdata.deliveredFailed"
            :last-updated-at="mainDashboard.deliveredFailedData.last_updated_at"
            queue="status-statistics"
            @refresh="fetchWidgetRefreshTime"
          />
        </div>
      </b-col>
    </b-row>

    <b-row class="match-height">
      <!-- Revenue Report Card -->
      <b-col
        md="12"
      >
        <div v-if="!isMerchantOnBoarding">
          <ecommerce-client-onboarded
            title="Merchants Onboarded"
            :data="tempdata.clientOnBoarded"
            :last-updated-at="mainDashboard.MerchantOnBoardingData.last_updated_at"
            queue="merchant-onboarding"
            @refresh="fetchWidgetRefreshTime"
          />
        </div>
      </b-col>
      <!--/ Revenue Report Card -->
    </b-row>

    <!-- <b-row class="match-height">
      <b-col
        md="12"
      >
        <div v-if="!isGroupedBarChartLoading && aiModuleEnabled && aiEnabled">
          <div class="kpi-dashboard-alert">
            <b-alert
              variant="warning"
              show
              class="d-flex align-items-center justify-content-center text-align-center small"
            >
              This is the beta version of the Delivery Success Rate (DSR) KPI Dashboard.
            </b-alert>
          </div>
          <GroupedBarChart
            :data="tempdata.chartData"
          />
        </div>
      </b-col>
    </b-row> -->

    <b-row class="match-height">
      <!-- Citywise Statistic card -->
      <b-col
        md="12"
      >
        <div v-if="!isCitywiseStatsLoading">
          <ecommerce-client-onboarded
            title="Citywise Delivery Statistics"
            :data="tempdata.cityWiseStats"
            :last-updated-at="mainDashboard.cityWiseStatsData.last_updated_at"
            queue="citywise-stats"
            chart-color="#89F280"
            @refresh="fetchWidgetRefreshTime"
          />
        </div>
      </b-col>
      <!--/ Revenue Report Card -->
    </b-row>

    <b-row class="match-height">
      <!-- Company Table Card -->
      <b-col lg="12">
        <div v-if="!isMStatusStatistics">
          <ecommerce-company-table
            :table-data="tempdata.companyTable.data"
            :last-updated-at="mainDashboard.statusStatisticsData.last_updated_at"
            queue="status-statistics"
            @refresh="fetchWidgetRefreshTime"
          />
        </div>
      </b-col>
      <!--/ Company Table Card -->
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
// import BCardCode from '@core/components/b-card-code'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import EcommerceStatistics from '@/components/Dashboard/EcommerceStatistics.vue'
import EcommerceTransactions from '@/components/Dashboard/EcommerceTransactions.vue'
import EcommerceFinancialStatistics from '@/components/Dashboard/EcommerceFinancialStatistics.vue'
import EcommerceRevenueReport from '@/components/Dashboard/EcommerceRevenueReport.vue'
import EcommerceMonthlyEarningsChart from '@/components/Dashboard/EcommerceMonthlyEarning.vue'
import EcommerceCompanyTable from '@/components/Dashboard/EcommerceCompanyTable.vue'
import EcommerceClientOnboarded from '@/components/Dashboard/EcommerceClientOnboarded.vue'
import EcommerceDeliveredFailed from '@/components/Dashboard/EcommerceDeliveredFailed.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
// import GroupedBarChart from '@/components/Dashboard/GroupedBarChart.vue'

const DashboardRepository = RepositoryFactory.get('dashboard')
// eslint-disable-next-line no-unused-vars
const BusinessSettingsRepository = RepositoryFactory.get('businessSetting')
const ResourceRepository = RepositoryFactory.get('resource')
const AiSettingRepository = RepositoryFactory.get('aiSetting')

export default {
  components: {
    EcommerceClientOnboarded,
    BRow,
    BCol,
    // BAlert,
    // BCardCode,
    EcommerceTransactions,
    EcommerceStatistics,
    EcommerceRevenueReport,
    EcommerceFinancialStatistics,
    EcommerceMonthlyEarningsChart,
    EcommerceCompanyTable,
    EcommerceDeliveredFailed,
    // GroupedBarChart,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      mainDashboard: {
        orderStatsData: {},
        financialStatsData: {},
        monthlyOrdersData: {},
        monthlyEarningsData: {},
        toBeInvoicesData: {},
        deliveredFailedData: {},
        MerchantOnBoardingData: {},
        statusStatisticsData: {},
        cityWiseStatsData: {},
        groupedBarChartData: {},
      },
      businessProfileCurrency: null,
      aiEnabled: false,
      aiModuleEnabled: false,
      data: {},
      isBarChartLoading: false,
      isMonthlyEarningsLoading: false,
      isToBeInvoicesLoading: false,
      isDeliveredFailedLoading: false,
      isMerchantOnBoarding: false,
      isMStatusStatistics: false,
      isCitywiseStatsLoading: false,
      isGroupedBarChartLoading: false,
      tempdata: {
        chartData: {
          series: [
            {
              name: 'Forecasted',
              data: [],
            },
            {
              name: 'Actual Success',
              data: [],
            },
            {
              name: 'Actual Fail',
              data: [],
            },
          ],
        },
        statisticsItems: [
          {
            icon: 'BoxIcon',
            customClass: '',
            color: '#96CCFF',
            iconColor: '#0882F2',
            title: 0,
            subtitle: 'Orders Count',
            bgcolor: '#E8ECFF',
          },
          {
            icon: 'DollarSignIcon',
            customClass: 'ml-3',
            color: '#9EFF96',
            iconColor: '#15C006',
            title: 0,
            subtitle: 'Delivery Charge',
            bgcolor: '#E5F8ED',
          },
        ],
        financialstatisticsItems: [
          {
            icon: 'ShoppingBagIcon',
            customClass: '',
            color: '#96F2FF',
            iconColor: '#01AFC7',
            bgcolor: '#E0F9FC',
            title: 0,
            subtitle: 'Invoice Value',
          },
          {
            icon: 'LoaderIcon',
            customClass: '',
            color: '#FFAF96',
            iconColor: '#FB450B',
            bgcolor: '#FFF3E8',
            title: 0,
            subtitle: 'Pending Invoice',
          },
          {
            icon: 'CheckCircleIcon',
            customClass: '',
            color: '#96FFA0',
            iconColor: '#00D315',
            bgcolor: '#E5F8ED',
            title: 0,
            subtitle: 'Paid Invoice Value',
          },
          {
            icon: 'UserCheckIcon',
            customClass: '',
            color: '#96A6FF',
            iconColor: '#0026F6',
            bgcolor: '#E0F3FF',
            title: 0,
            subtitle: 'Approved Invoice',
          },
        ],
        monthlyEarnings: {
          categories:
              { lables: [] },
          series: [
            {
              name: 'Delivery Charge',
              data: [],
            },
          ],
        },
        toBeInvoices: [
          {
            avatarVariant: '#F6F0E4',
            iconColor: '#B7914D',
            avatar: 'CodesandboxIcon',
            mode: 'Collected COD',
            bgcolor: '#FFF9ED',
            types: this.businessProfileCurrency || (localStorage.getItem('businessCurrency') === 'ALL' ? 'LKR' : localStorage.getItem('businessCurrency')),
            deduction: false,
            payment: 0,
          },
          {
            avatarVariant: '#D6FCE7',
            iconColor: '#3A6A50',
            avatar: 'TruckIcon',
            mode: 'Delivery Charge',
            bgcolor: '#E5FFF1',
            types: this.businessProfileCurrency || (localStorage.getItem('businessCurrency') === 'ALL' ? 'LKR' : localStorage.getItem('businessCurrency')),
            deduction: false,
            payment: 0,
          },
          {
            avatarVariant: '#D8E8F1',
            iconColor: '#323D5A',
            avatar: 'PercentIcon',
            mode: 'Commission',
            bgcolor: '#EDF4FB',
            types: this.businessProfileCurrency || (localStorage.getItem('businessCurrency') === 'ALL' ? 'LKR' : localStorage.getItem('businessCurrency')),
            deduction: false,
            payment: 0,
          },
          {
            avatarVariant: '#E2D2F0',
            iconColor: '#473C51',
            avatar: 'DollarSignIcon',
            mode: 'Invoice Value',
            bgcolor: '#F8F1FF',
            types: this.businessProfileCurrency || (localStorage.getItem('businessCurrency') === 'ALL' ? 'LKR' : localStorage.getItem('businessCurrency')),
            deduction: false,
            payment: 0,
          },
        ],
        monthlyOrders: {
          categories:
            { lables: [] },
          series: [
            { data: [] },
          ],
        },
        clientOnBoarded: {
          categories:
              { lables: [] },
          series: [
            {
              name: 'Merchants',
              data: [],
            },
          ],
        },
        companyTable: {
          data: [],
        },
        deliveredFailed: {
          series: [],
        },
        cityWiseStats: {
          categories:
              { lables: [] },
          series: [
            {
              name: 'Delivered orders',
              data: [],
            },
          ],
        },
      },
      isRefreshing: false,
      refreshingQueue: null,
      refreshTimeoutId: null,
      widgetConfig: {
        'finance-statistics': { fetcher: 'readDataforFinancialStats', dataProp: 'financialStatsData' },
        'monthly-orders': { fetcher: 'readDataforMonthlyOrders', dataProp: 'monthlyOrdersData' },
        'monthly-earnings': { fetcher: 'readDataforMonthlyEarnings', dataProp: 'monthlyEarningsData' },
        'to-be-invoice': { fetcher: 'readDataforToBeInvoices', dataProp: 'toBeInvoicesData' },
        'merchant-onboarding': { fetcher: 'readDataforMerchantOnBoarding', dataProp: 'MerchantOnBoardingData' },
        // 'dsr-kpi':               { fetcher: 'readDataForDSRKPI',            dataProp: 'groupedBarChartData' },
        'citywise-stats': { fetcher: 'readDataforCitywiseStats', dataProp: 'cityWiseStatsData' },
        'status-statistics': { fetcher: 'readDataforOrderStats', dataProp: 'orderStatsData' },
      },
    }
  },
  created() {
    this.fetchModules()
    this.readAiSetting()
    this.getDashboardDetails()
    // Listen for refreshDashboardData event emitted from AppBreadCrumb.vue
    this.$root.$on('refreshDashboardData', this.getDashboardDetails)
  },
  async beforeCreate() {
    await this.getBusinessCurrency()
  },
  beforeDestroy() {
    this.$root.$off('refreshDashboardData', this.getDashboardDetails)
    if (this.refreshTimeoutId) {
      clearTimeout(this.refreshTimeoutId)
    }
  },
  methods: {
    currentDate() {
      const current = new Date()
      return `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`
    },
    getDashboardDetails() {
      // Set the initial number of items
      this.readDataforOrderStats()
      this.readDataforFinancialStats()
      this.readDataforMonthlyOrders()
      this.readDataforMonthlyEarnings()
      this.readDataforToBeInvoices()
      this.readDataforDeliveredFailed()
      this.readDataforMerchantOnBoarding()
      this.readDataForDSRKPI()
      this.readDataforStatusStatistics()
      this.readDataforCitywiseStats()
      this.getBusinessCurrency()
    },
    async fetchModules() {
      try {
        this.loading = true
        const data = localStorage.getItem('module_data') ? JSON.parse(localStorage.getItem('module_data')) : (await ResourceRepository.getModules()).data.data
        if (!localStorage.getItem('module_data')) localStorage.setItem('module_data', JSON.stringify(data))
        const aiSettingModule = data.find(module => module.name === 'AI Setting')
        this.aiModuleEnabled = aiSettingModule ? aiSettingModule.is_active : false
      } catch (e) {
        // this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async readAiSetting() {
      this.loading = true
      try {
        const data = localStorage.getItem('ai_setting') ? JSON.parse(localStorage.getItem('ai_setting')) : (await AiSettingRepository.getAiSetting()).data.data
        if (!localStorage.getItem('ai_setting')) localStorage.setItem('ai_setting', JSON.stringify(data))
        this.aiEnabled = data.enabled
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async readDataforOrderStats() {
      try {
        const response = (await DashboardRepository.getOrderStatsFinance()).data

        this.mainDashboard.orderStatsData = {
          ...response,
          last_updated_at: response.data?.last_updated_at || null,
        }
        if (response && response.data) {
          this.tempdata.statisticsItems[0].title = response.data.order_count
          this.tempdata.statisticsItems[1].title = response.data.total_delivery_charge
        }
        // this.tempdata.statisticsItems.lastUpdatedAt = this.mainDashboard.orderStatsData.last_updated_at
      } catch (e) {
        // Check if the error has a response and the status code is 401
        if (!e.response || e.response.status !== 401) {
          this.convertAndNotifyError(e)
        }
      }
    },
    async readDataForDSRKPI() {
      this.isGroupedBarChartLoading = true
      try {
        const mainDashboardDataString = localStorage.getItem('main-dashboard')
        const mainDashboardData = JSON.parse(mainDashboardDataString)

        if (mainDashboardDataString && mainDashboardData.groupedBarChartData) {
          this.mainDashboard = mainDashboardData
        } else {
          const { data } = await DashboardRepository.getDataForDSRKPI()

          // The response is now an array, so directly assign it
          this.mainDashboard.groupedBarChartData = data.data

          // Save the structured data to local storage
          localStorage.setItem('main-dashboard', JSON.stringify(this.mainDashboard))
        }

        // Set the chart data series based on the new structure
        this.tempdata.chartData.series[1].data = this.mainDashboard.groupedBarChartData.map(n => n.correct_values)
        this.tempdata.chartData.series[2].data = this.mainDashboard.groupedBarChartData.map(n => n.incorrect_values)

        // Calculate the sum of correct and incorrect values
        const correctValues = this.mainDashboard.groupedBarChartData.map(n => n.correct_values)
        const incorrectValues = this.mainDashboard.groupedBarChartData.map(n => n.incorrect_values)
        const sumValues = correctValues.map((value, index) => parseInt(value, 10) + parseInt(incorrectValues[index], 10))

        this.tempdata.chartData.series[0].data = sumValues
      } catch (e) {
        if (!e.response || e.response.status !== 401) {
          this.convertAndNotifyError(e)
        }
      }
      this.isGroupedBarChartLoading = false
    },
    async readDataforFinancialStats() {
      try {
        const response = (await DashboardRepository.getFinancialStatFinance()).data
        this.mainDashboard.financialStatsData = response
        if (response && response.data) {
          this.tempdata.financialstatisticsItems[0].title = response.data.total_invoice_amount
          this.tempdata.financialstatisticsItems[1].title = response.data.status_amount.filter(item => item.status_key === 'f_key_1').length > 0 ? response.data.status_amount.filter(item => item.status_key === 'f_key_1')[0].amount : 0
          this.tempdata.financialstatisticsItems[2].title = response.data.status_amount.filter(item => item.status_key === 'f_key_2').length > 0 ? response.data.status_amount.filter(item => item.status_key === 'f_key_2')[0].amount : 0
          this.tempdata.financialstatisticsItems[3].title = response.data.status_amount.filter(item => item.status_key === 'f_key_3').length > 0 ? response.data.status_amount.filter(item => item.status_key === 'f_key_3')[0].amount : 0
        }
      } catch (e) {
        // Check if the error has a response and the status code is 401
        if (!e.response || e.response.status !== 401) {
          this.convertAndNotifyError(e)
        }
      }
    },
    async readDataforMonthlyOrders() {
      this.isBarChartLoading = true
      try {
        const response = (await DashboardRepository.getMonthlyOrdersFinance()).data
        this.mainDashboard.monthlyOrdersData = response
        if (response && response.data) {
          this.tempdata.monthlyOrders.categories.lables = response.data
            .map(n => {
              const date = new Date(`${n.month} 1, ${n.year}`)
              const shortMonth = date.toLocaleString('en-US', { month: 'short' })
              const shortYear = String(n.year).slice(-2)
              return `${shortMonth}'${shortYear}`
            }).reverse().slice(-12)
          this.tempdata.monthlyOrders.series[0].data = response.data.map(n => n.data).reverse().slice(-12)
        }
      } catch (e) {
        // Check if the error has a response and the status code is 401
        if (!e.response || e.response.status !== 401) {
          this.convertAndNotifyError(e)
        }
      }
      this.isBarChartLoading = false
    },
    async readDataforMonthlyEarnings() {
      this.isMonthlyEarningsLoading = true
      try {
        const response = (await DashboardRepository.getMonthlyEarningsFinance()).data
        this.mainDashboard.monthlyEarningsData = response
        if (response && response.data && response.data.length > 0) {
          this.tempdata.monthlyEarnings.categories.lables = response.data
            .map(n => {
              const date = new Date(`${n.month} 1, ${n.year}`)
              const shortMonth = date.toLocaleString('en-US', { month: 'short' })
              const shortYear = String(n.year).slice(-2)
              return `${shortMonth}'${shortYear}`
            }).reverse().slice(-12)
          this.tempdata.monthlyEarnings.series[0].data = response.data.map(n => n.delivery_charge).reverse().slice(-12)
        } else {
          this.tempdata.monthlyEarnings.categories.lables = this.currentDate()
          this.tempdata.monthlyEarnings.series[0].data = [0]
        }
      } catch (e) {
        // Check if the error has a response and the status code is 401
        if (!e.response || e.response.status !== 401) {
          this.convertAndNotifyError(e)
        }
      }
      this.isMonthlyEarningsLoading = false
    },
    async readDataforToBeInvoices() {
      this.isToBeInvoicesLoading = true
      try {
        const response = (await DashboardRepository.getToBEInvoicesFinance()).data
        this.mainDashboard.toBeInvoicesData = response
        if (response && response.data) {
          const invoiceData = response.data[0] || {}
          this.tempdata.toBeInvoices[0].payment = invoiceData.collected_cod || 0
          this.tempdata.toBeInvoices[1].payment = invoiceData.delivery_charge || 0
          this.tempdata.toBeInvoices[2].payment = invoiceData.commission || 0
          this.tempdata.toBeInvoices[3].payment = invoiceData.to_be_invoice_amount || 0
        }
      } catch (e) {
        // Check if the error has a response and the status code is 401
        if (!e.response || e.response.status !== 401) {
          this.convertAndNotifyError(e)
        }
      }
      this.isToBeInvoicesLoading = false
    },
    async readDataforDeliveredFailed() {
      this.isDeliveredFailedLoading = true
      try {
        const response = (await DashboardRepository.getDeliveredFailedData()).data
        this.mainDashboard.deliveredFailedData = {
          ...response,
          last_updated_at: response.data?.last_updated_at || null,
        }
        if (response && response.data) {
          this.tempdata.deliveredFailed.series[0] = response.data.delivered_count
          this.tempdata.deliveredFailed.series[1] = response.data.failed_count
        }
      } catch (e) {
        // Check if the error has a response and the status code is 401
        if (!e.response || e.response.status !== 401) {
          this.convertAndNotifyError(e)
        }
      }
      this.isDeliveredFailedLoading = false
    },
    async readDataforMerchantOnBoarding() {
      this.isMerchantOnBoarding = true
      try {
        const response = (await DashboardRepository.getMerchantOnBoardingFinance()).data
        this.mainDashboard.MerchantOnBoardingData = response
        if (response && response.data) {
          this.tempdata.clientOnBoarded.categories.lables = response.data
            .map(n => {
              const date = new Date(`${n.month} 1, ${n.year}`)
              const shortMonth = date.toLocaleString('en-US', { month: 'short' })
              const shortYear = String(n.year).slice(-2)
              return `${shortMonth}'${shortYear}`
            }).reverse().slice(-12)
          this.tempdata.clientOnBoarded.series[0].data = response.data.map(n => n.data).reverse().slice(-12)
        }
      } catch (e) {
        // Check if the error has a response and the status code is 401
        if (!e.response || e.response.status !== 401) {
          this.convertAndNotifyError(e)
        }
      }
      this.isMerchantOnBoarding = false
    },
    async readDataforStatusStatistics() {
      this.isMStatusStatistics = true
      try {
        const response = (await DashboardRepository.getStatusStatisticsFinance()).data
        this.mainDashboard.statusStatisticsData = response
        if (response && response.data) {
          this.tempdata.companyTable.data = response.data
        }
      } catch (e) {
        // Check if the error has a response and the status code is 401
        if (!e.response || e.response.status !== 401) {
          this.convertAndNotifyError(e)
        }
      }
      this.isMStatusStatistics = false
    },
    async readDataforCitywiseStats() {
      this.isCitywiseStatsLoading = true
      try {
        const response = (await DashboardRepository.getCityWiseStats()).data
        this.mainDashboard.cityWiseStatsData = response
        if (response && response.data) {
          this.tempdata.cityWiseStats.categories.lables = response.data.map(n => (`${n.city_name}`))
          this.tempdata.cityWiseStats.series[0].data = response.data.map(n => n.count)
        }
      } catch (e) {
        // Check if the error has a response and the status code is 401
        if (!e.response || e.response.status !== 401) {
          this.convertAndNotifyError(e)
        }
      }
      this.isCitywiseStatsLoading = false
    },
    async getBusinessCurrency() {
      try {
        const { data: { company_currency } } = (await BusinessSettingsRepository.getbusinessSettingsResource()).data
        if (localStorage.getItem('businessCurrency') === true) {
          localStorage.removeItem('businessCurrency')
        }
        localStorage.setItem('businessCurrency', company_currency)
        // eslint-disable-next-line camelcase
        this.businessProfileCurrency = company_currency
      } catch (e) {
        // Check if the error has a response and the status code is 401
        if (!e.response || e.response.status !== 401) {
          this.convertAndNotifyError(e)
        }
        this.businessProfileCurrency = 'LKR'
      }
    },
    // related to refresh,polling
    async fetchWidgetRefreshTime(queue) {
      // disable duplicate loops
      if (queue === 'status-statistics') {
        this.isRefreshing = true
        try {
          // Start the backend job
          await DashboardRepository.DashboardQueueStart(queue)
          this.showSuccessMessage('Refresh initiated..')
          // Manually trigger ALL THREE data fetches in parallel
          await Promise.all([
            this.readDataforOrderStats(),
            this.readDataforDeliveredFailed(),
            this.readDataforStatusStatistics(),
          ])
        } catch (e) {
          this.convertAndNotifyError(e)
        } finally {
          this.isRefreshing = false
        }
        // IMPORTANT: Stop the function here for the special case
        return
      }
      this.isRefreshing = true
      if (this.refreshTimeoutId) {
        clearTimeout(this.refreshTimeoutId)
        this.refreshTimeoutId = null
      }
      // remember the “old” timestamp
      const { dataProp } = this.widgetConfig[queue]
      const prevTsStr = this.mainDashboard[dataProp]?.last_updated_at || null
      try {
        // kick off your backend job
        await DashboardRepository.DashboardQueueStart(queue)
        this.showSuccessMessage('Refresh initiated...')
        // begin polling until we see last_updated_at > prevTsStr
        this.startPolling(queue, prevTsStr)
      } catch (e) {
        this.convertAndNotifyError(e)
        this.isRefreshing = false
      }
    },
    startPolling(queue, prevTsStr) {
      const { fetcher, dataProp } = this.widgetConfig[queue]
      const prevMs = prevTsStr ? Date.parse(prevTsStr) : 0
      const doPoll = async () => {
        try {
          // re-fetch only this widget’s data
          await this[fetcher]()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        // read the new timestamp
        const newTsStr = this.mainDashboard[dataProp]?.last_updated_at || null
        const newMs = newTsStr ? Date.parse(newTsStr) : 0
        if (newMs > prevMs) {
          // success: clear the pending timeout and stop
          if (this.refreshTimeoutId) {
            clearTimeout(this.refreshTimeoutId)
            this.refreshTimeoutId = null
          }
          this.isRefreshing = false
          this.showSuccessMessage(`${queue} updated at ${newTsStr}`)
        } else {
          this.refreshTimeoutId = setTimeout(doPoll, 10000)
        }
      }
      // ensure no stray timeout remains
      if (this.refreshTimeoutId) {
        clearTimeout(this.refreshTimeoutId)
        this.refreshTimeoutId = null
      }
      // kick off the first poll immediately
      doPoll()
    },
  },
}
</script>

<style lang="scss">
@import '../@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '../@core/scss/vue/libs/chart-apex.scss';
.kpi-dashboard-alert .alert {
  line-height: 30px;
}
.dashboard-scale {
  zoom: 0.8;
}
</style>
